/**
 * Created by Tiger on 29/06/2022.
 */

import React, {useEffect, useRef} from "react";
import {Button, Form, Input, Modal} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import i18n from "i18next";
import styled from "@emotion/styled";
import {FormInstance} from "antd/es/form";

type Fields = {
  [key: string]: string
}

interface CustomConfigFieldProps {
  onOk: (value: Fields) => void;
  visible: boolean;
  onCancel: () => {};
  fields: Fields | null | undefined
}

export default function CustomConfigField({onOk, visible, onCancel, fields}: CustomConfigFieldProps) {
  const onFinish = (values: { [fields: string]: { Key: string, Value: string }[] }) => {
    const customFields: {
      [key: string]: string
    } = {}
    values.fields.forEach(({Key, Value}) => {
      customFields[Key] = Value
    })
    console.log('Received values of form:', values, customFields)
    onOk(customFields)
  }
  const [customConfigForm] = Form.useForm()
  useEffect(() => {
    if (fields && customConfigForm) {
      let newFields: { Key: string, Value: string, name: string }[] = []
      Reflect.ownKeys(fields).forEach(key => {
        newFields.push({
          Key: key as string,
          name: key as string,
          Value: Reflect.get(fields, key)
        })
      })
      console.log('newFields：', newFields)
      customConfigForm.setFieldsValue({
        fields: newFields
      })
    }
    console.log('1212', fields, customConfigForm)
  }, [fields, customConfigForm])
  return (
    <Modal
      title={i18n.t('custom_config')}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={document.body.clientWidth / 3}
    >
      <Form form={customConfigForm} layout={'horizontal'} name={'dynamic_form_nest_item'} onFinish={onFinish}
            autoComplete={'off'}>
        <Form.List name={'fields'}>
          {
            (fields, {add, remove}) => (
              <>
                {
                  fields.map(({key, name, ...restField}) => (
                    <Space key={key}>
                      <Form.Item
                        style={{flex: 1}}
                        label={'Key'}
                        {...restField}
                        name={[name, 'Key']}
                        rules={[{required: true,}]}
                      >
                        <Input/>
                      </Form.Item>
                      <Form.Item
                        style={{flex: 1}}
                        label={'Value'}
                        {...restField}
                        name={[name, 'Value']}
                        rules={[{required: true,}]}
                      >
                        <Input/>
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)}/>
                    </Space>
                  ))
                }
                <Form.Item>
                  <Button type={"dashed"} onClick={() => add()} block icon={<PlusOutlined/>}>
                    {i18n.t('add')}
                  </Button>
                </Form.Item>
              </>
            )
          }
        </Form.List>
        <Form.Item>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: 20,}}>
            <Button onClick={() => onCancel()}>{i18n.t('cancel')}</Button>
            <Button style={{marginLeft: 5}} type={'primary'} htmlType={'submit'}>
              {i18n.t('confirm')}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  )
}

const Space = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
`
